export interface ButtonModel{
    name: string;
    key: string;
    color?: string;
}